import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; //@ts-check

import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { withStyles, createStyles } from '@material-ui/core';
import Form from '../../../../../form';
import Utils from '../../../../../utils';

var styles = function styles(theme) {
  return createStyles(theme.components);
};

var UploadVersionDialog = function UploadVersionDialog(props) {
  var onClose = props.onClose,
      onSubmit = props.onSubmit;
  var filePath = props.filePath,
      workspace = props.workspace;

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      defaultValue = _React$useState2[0],
      setDefaultValue = _React$useState2[1];

  React.useEffect(function () {
    Utils.apiClients.tags.getTags(workspace, filePath).then(function (tags) {
      var versionsTag = tags.find(function (t) {
        return t.Name === 'HasVersions';
      });
      setDefaultValue({
        HasVersions: !versionsTag || versionsTag.Value.toLowerCase() === 'true',
        HasVersionsTag: !!versionsTag
      });
    }, function () {
      setDefaultValue({
        HasVersions: true,
        HasVersionsTag: false
      });
    });
  }, []);

  var onValidate = function onValidate(data) {
    if (!data || !data.File) return {
      FORM: 'File field is missing'
    };
    return {};
  };

  var onSuccess = function onSuccess(data) {
    var HasVersions = data.HasVersions,
        HasVersionsTag = data.HasVersionsTag,
        File = data.File,
        Comment = data.Comment;
    var formData = new FormData();
    formData.append('file', File);
    formData.append('comment', Comment || '');
    return new Promise(function (resolve, reject) {
      // has versions changed
      if (!HasVersionsTag || HasVersions != defaultValue.HasVersions) {
        Utils.apiClients.tags.addTag(workspace, filePath, {
          Name: 'HasVersions',
          Value: '' + HasVersions,
          IsSystemProperty: false,
          IsUserTag: 'false'
        }).then(function () {
          Utils.request({
            method: 'POST',
            url: "/backend/content?workspace=".concat(encodeURIComponent(workspace), "&filePath=").concat(encodeURIComponent(filePath)),
            data: formData
          }).then(function () {
            resolve();
            onSubmit();
            onClose();
          }, reject);
        }, reject);
      } else Utils.request({
        method: 'POST',
        url: "/backend/content?workspace=".concat(encodeURIComponent(workspace), "&filePath=").concat(encodeURIComponent(filePath)),
        data: formData
      }).then(function () {
        resolve();
        onSubmit();
        onClose();
      }, reject);
    });
  };

  var renderContent = function renderContent() {
    return React.createElement(Grid, {
      container: true,
      direction: "column"
    }, React.createElement(Grid, {
      item: true,
      xs: true
    }, React.createElement(Form.Fields.LocalFile, {
      name: "File",
      label: null,
      placeholder: "No file selected. Pick an xml file.",
      accept: ".xml"
    })), React.createElement(Grid, {
      item: true,
      xs: true
    }, React.createElement(Form.Fields.Checkbox, {
      name: "HasVersions",
      label: "Has versioning"
    })), React.createElement(Grid, {
      item: true,
      xs: true
    }, React.createElement(Typography, {
      style: {
        fontWeight: 'bold'
      }
    }, "Comment"), React.createElement(Form.Fields.Text, {
      name: "Comment",
      variant: "filled",
      label: null,
      multiline: true,
      rows: 3
    })));
  };

  return React.createElement(Form.Dialog, {
    renderContent: renderContent,
    defaultValue: defaultValue,
    onValidate: onValidate,
    onSuccess: onSuccess,
    onCancel: onClose,
    disabled: !defaultValue,
    submitLabel: "Upload",
    submittingLabel: "Uploading",
    windowProps: {
      header: "Upload New Version"
    }
  });
};

export default withStyles(styles, {
  withTheme: true,
  name: 'ECUploadVersionDialog'
})(UploadVersionDialog);